"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartWalletAuth = void 0;
const ethers_1 = require("ethers");
const auth_dto_1 = require("../types/auth/auth.dto");
/// Class for handling authentication processes for Fuse Smart Wallets.
class SmartWalletAuth {
}
exports.SmartWalletAuth = SmartWalletAuth;
_a = SmartWalletAuth;
/**
 * Authenticates the user using the provided private key
 * @param {EOASigner} credentials are the private key credentials.
 * @param {string} smartWalletAddress is the address of the smart wallet to authenticate.
 * @returns  AuthDto, containing the hash, ownerAddress and signature of the authenticated wallet.
 */
SmartWalletAuth.signer = (credentials, smartWalletAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const ownerAddress = yield credentials.getAddress();
    const input = Uint8Array.from(Buffer.from(ownerAddress.replace('0x', ''), 'hex'));
    const hash = ethers_1.ethers.utils.keccak256(input);
    const signature = yield credentials.signMessage(ethers_1.ethers.utils.arrayify(hash));
    return new auth_dto_1.AuthDto(ownerAddress, signature, hash, smartWalletAddress);
});
